import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import BroadcastNotificationModal from "../General/BroadcastNotificationModal";
import { Spinner } from "react-bootstrap";
import BonusModal from "../General/BonusModal";
import ReplaceDeveloperSalesModal from "./ReplaceDeveloperSalesModal";
import CommissionCompaniesTable from "../CommissionCompanies/CommissionCompaniesTable";
import ResaleSettingsCard from "./ResaleSettingsCard";

const SettingsLayer = () => {
  const [settings, setSettings] = useState({
    tax_rate: "",
    broker_percent: "",
    time_rt: "",
    time_at: "",
  });
  const [loading, setLoading] = useState(true);

  // State to track whether the broadcast modal is open
  const [showBroadcastModal, setShowBroadcastModal] = useState(false);
  const [showBonusModal, setShowBonusModal] = useState(false);
  const [showReplaceSalesModal, setShowReplaceSalesModal] = useState(false);

  useEffect(() => {
    // Fetch settings with toasts on success/error
    api
      .get("/settings")
      .then((res) => {
        if (res.data.status) {
          setSettings(res.data.response);
          toast.success("Settings loaded successfully");
        } else {
          toast.error("Failed to load settings");
        }
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
        toast.error("Failed to fetch settings");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleUpdate = (name, value) => {
    setLoading(true);
    api
      .put("/settings", { name, value: parseFloat(value) })
      .then((res) => {
        if (res.data.status) {
          toast.success(`${name} updated successfully`);
        } else {
          toast.error(`Failed to update ${name}`);
        }
      })
      .catch((error) => {
        console.error("Error updating setting:", error);
        toast.error(`Error updating ${name}`);
      });
    setLoading(false);
  };

  if (loading) return <p>Loading settings...</p>;

  // Mapping for custom labels
  const friendlyLabels = {
    time_rt: "Refresh Token TTL ( minutes )",
    time_at: "Access Token TTL ( minutes )",
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden">
      <div className="card-body p-40">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            {Object.keys(settings).map((key) => (
              <div className="col-sm-6" key={key}>
                <div className="mb-20">
                  <label
                    htmlFor={key}
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                  >
                    {friendlyLabels[key] ||
                      key.replace("_", " ").toUpperCase()}
                  </label>
                  <input
                    type="number"
                    className="form-control radius-8 mb-3"
                    id={key}
                    name={key}
                    value={settings[key]}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-primary radius-8"
                    onClick={() => handleUpdate(key, settings[key])}
                    disabled={loading}
                  >
                    {loading ? <Spinner animation="border" size="sm" /> : 'Update'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </form>

        {/* Buttons for additional features */}
        <div className="mt-4 d-flex gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => setShowBroadcastModal(true)}
          >
            Send Broadcast
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => setShowBonusModal(true)}
          >
            Add Bonus/Incentive
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => setShowReplaceSalesModal(true)}
          >
            Replace Developer Sales
          </button>
        </div>

        {/* Resale Units Section */}
        <div className="mt-5">
          <ResaleSettingsCard />
        </div>

        {/* Commission Companies Section */}
        <div className="mt-5">
          <CommissionCompaniesTable />
        </div>
      </div>

      {/* Modals */}
      <BroadcastNotificationModal
        show={showBroadcastModal}
        handleClose={() => setShowBroadcastModal(false)}
      />
      <BonusModal
        show={showBonusModal}
        handleClose={() => setShowBonusModal(false)}
      />
      <ReplaceDeveloperSalesModal
        show={showReplaceSalesModal}
        handleClose={() => setShowReplaceSalesModal(false)}
      />
    </div>
  );
};

export default SettingsLayer;
